export class NumberUtils {
  static getDecimalPart(num: any) {
    if (Number.isInteger(num)) {
      return 0;
    }

    const decimalStr = num.toString().split('.')[1];
    return Number(decimalStr);
  }
}